import { create } from 'zustand'

interface BlogPostsViewStore {
  view: 'table' | 'card'
  changeView: (newView: 'table' | 'card') => void
}

const blogPostsViewStore = (set: any) => ({
  view: 'table' as 'table' | 'card',
  changeView: (newView: 'table' | 'card') => set(() => ({ view: newView })),
})

export const useBlogPostsViewStore = create<BlogPostsViewStore>(blogPostsViewStore)